var map = {
	"./anchor-blue.svg": 1777,
	"./arr-down.svg": 1778,
	"./arr-up.svg": 1779,
	"./arrow-down-blue.svg": 1780,
	"./arrow-down-circle.svg": 1781,
	"./arrow-down.svg": 1782,
	"./arrow-left.svg": 1783,
	"./arrow-right.svg": 1784,
	"./arrow-up-circle.svg": 1785,
	"./arrow-up.svg": 1786,
	"./article.svg": 1787,
	"./basket-light.svg": 1788,
	"./basket.svg": 1789,
	"./btn-arrow-dark.svg": 1790,
	"./btn-arrow-down-blue.svg": 1791,
	"./btn-arrow-down.svg": 1792,
	"./btn-arrow.svg": 1793,
	"./btn-info.svg": 1794,
	"./btn-play.svg": 1795,
	"./calendar.svg": 1796,
	"./chevron-down.svg": 1797,
	"./chevron-left.svg": 1798,
	"./chevron-right.svg": 1799,
	"./chevron-up.svg": 1800,
	"./clock.svg": 1801,
	"./cross.svg": 1802,
	"./curve-shape-narrow-swoosh.svg": 1803,
	"./curve-shape-right.svg": 1804,
	"./curve-shape-short.svg": 1805,
	"./curve-shape.svg": 1806,
	"./facebook.svg": 1807,
	"./gallery.svg": 1808,
	"./i.svg": 1809,
	"./instagram.svg": 1810,
	"./linkedin.svg": 1811,
	"./live-header-logo.svg": 1812,
	"./logo-aig-wo-short.svg": 1813,
	"./logo-aig-wo-venue.svg": 1814,
	"./logo-aig-wo.svg": 1815,
	"./logo-open.svg": 1816,
	"./menu-close.svg": 1817,
	"./menu-light.svg": 1818,
	"./minus.svg": 1819,
	"./mute.svg": 1820,
	"./pause.svg": 1821,
	"./play.svg": 1822,
	"./plus.svg": 1823,
	"./profile-light.svg": 1824,
	"./radioff.svg": 1825,
	"./radion.svg": 1826,
	"./read.svg": 1827,
	"./restart.svg": 1828,
	"./scores.svg": 1829,
	"./search.svg": 1830,
	"./sorting.svg": 1831,
	"./star.svg": 1832,
	"./symbol.svg": 1833,
	"./text.svg": 1834,
	"./tick.svg": 1835,
	"./ticket.svg": 1836,
	"./tiktok.svg": 1837,
	"./track.svg": 1838,
	"./triangle.svg": 1839,
	"./twitter.svg": 1840,
	"./unmute.svg": 1841,
	"./video.svg": 1842,
	"./watch.svg": 1843,
	"./youtube.svg": 1844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 883;